import { useContext } from "react";
import { useFormikContext } from "formik";
import without from "lodash-es/without";

import { AppThemeGradientContext } from "contexts/appCustomization/AppThemeGradientContext";

import { DARK, LIGHT } from "constants/appModes";

export default function useGradientSection() {
  const { values: orders, setValues: setOrders } = useContext(
    AppThemeGradientContext,
  );
  const {
    values: {
      mode,
      [LIGHT]: { gradient: lightGradient, primary: lightPrimary },
      [DARK]: { gradient: darkGradient, primary: darkPrimary },
    },
  } = useFormikContext();
  const name = `${mode}.gradient`;
  const isDark = mode === DARK;
  const gradients = isDark ? darkGradient : lightGradient;
  const primary = isDark ? darkPrimary : lightPrimary;
  const order = orders[mode];

  const onChangeOrder = (data) => {
    setOrders((prev) => {
      if (Array.isArray(data)) return { ...prev, [mode]: data };
      const index = prev[mode].indexOf(data);
      if (index === -1) {
        const newData = prev[mode].concat(data);
        return { ...prev, [mode]: newData };
      }
      const newData = without(prev[mode], data);
      return { ...prev, [mode]: newData };
    });
  };

  return {
    gradients,
    primary,
    name,
    order,
    onChangeOrder,
  };
}
